import provideDataHook from '~/helpers/provideDataHook';
import { objectsFilterDataHook } from '../objectsFilterDataHook';
import { RedirectHandler } from '../RedirectHandler';

export default provideDataHook(
  'FilterPage-AllVehicles',
  objectsFilterDataHook({}),
  { skipSpinner: true }
)(RedirectHandler);
